import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AlertService } from '../../services/alert.service';
import { AuthService } from '../../services/auth.service';
import { AccessControlService } from 'src/app/services/access-control.service';
import { CheckPermissionService } from 'src/app/services/check-permission.service';
import swal from 'sweetalert2';
import { createElementCssSelector } from '@angular/compiler';
import { RoleTypeEnum } from 'src/app/enum/roles.enum';
// declare var $: any;
@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.css']
})
export class PermissionsComponent implements OnInit {
  private _array = Array;
  id: any;
  name: any;
  systemmoduleList: any = [];
  permissionModel: any = [];
  model: any = [];
  app_id: any;
  username: any;
  user_id: any;
  isprocessing: boolean = false;
  isLoading:boolean
  // tempSystemModules: any = [];
  is_Array: boolean;
  applicationName: any;
  clientId:any;
  isAnyModuleVisible:boolean=false;
  mode:RoleTypeEnum;
  constructor(private activateRoute: ActivatedRoute,
    private authService: AuthService,
    private alertService: AlertService,
    private accesscontrolService: AccessControlService,
    private router: Router,
    private checkPermissionService: CheckPermissionService) {
    this.id = this.activateRoute.snapshot.queryParamMap.get('id');
    this.app_id = this.activateRoute.snapshot.queryParamMap.get('app_id');
    this.name=this.activateRoute.snapshot.queryParamMap.get('name');
    this.clientId=localStorage.getItem("org_id");
  }

  ngOnInit() {
    this.mode=localStorage.getItem("type")=="0"?RoleTypeEnum.ORGANIZATION_ROLE:RoleTypeEnum.CLIENT_ROLE;
    if(this.mode==RoleTypeEnum.CLIENT_ROLE)
    this.clientId=localStorage.getItem("org_id");
    else{
      this.activateRoute.queryParamMap.subscribe((params:ParamMap)=>{
       this.clientId=params.get("org_id");
      })
    }
    this.activateRoute.queryParamMap.subscribe((query: any) => {
      this.applicationName = query.params["appname"]
    })
    this.username = localStorage.getItem('username');
    this.user_id = localStorage.getItem('user_id');
    this.getPermissionbyId();

  }

  getMatchedSection(sections: any) {
    var matchedSections: any = [];
    var tempSections = [];
    var itemsToRemove = [];

    sections.forEach(function (sec) {
      {
        matchedSections = sections.filter(function (parentSec) {
          return parentSec.inherited_from == sec.inherited_from && parentSec.inherited_from != null
        })
        //Get the parent
        if (matchedSections.length) {
          var psec = sections.filter(function (sect) {
            return sect._id == matchedSections[0].inherited_from
          });
          psec[0].isParent = true
          matchedSections.unshift(psec[0]);
          matchedSections._id = psec[0]._id;
          matchedSections.value = psec[0].value;
          matchedSections.section_display_name = psec[0].section_display_name;
          matchedSections.section_description = psec[0].section_description;
        }

        var flatArray = $.map(tempSections, function (n) {
          return n;
        });

        var is_inherited = sections.filter(function (pSec) {
          return pSec.inherited_from == sec._id
        })
        if (is_inherited.length == 0 && sec.inherited_from == null) {
          matchedSections = sec
        }
        else {
          matchedSections.forEach(function (existingSec) {
            if (flatArray.indexOf(existingSec) != -1)
              itemsToRemove.push(existingSec);

          })
          itemsToRemove.forEach(function (item) {
            matchedSections.splice($.inArray(item, matchedSections), 1);
          });
        }
        itemsToRemove = [];
        if (typeof matchedSections == 'object' && matchedSections != "")
          tempSections.push(matchedSections);
      }
    })
    return tempSections


  }
  getPermissionbyId() {

    this.isLoading = true;
    this.authService.getPermissionbyId(this.id,this.app_id,this.clientId).subscribe((res) => {
      this.systemmoduleList=res["permissions"];
      //this.name = res["name"];
      this.isAnyModuleVisible=(this.systemmoduleList || []).some(m=>(m.visibileForClient || []).some(x=>x==this.clientId)==true);
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
    }, () => {
    })
  }
  changemoduleStatus(module_value: any, module_id: any) {
    var is_module: boolean = false
    is_module=!module_value;
    if (this.systemmoduleList) {
      //Modules
      for (var i = 0; i < this.systemmoduleList.length; i++) {
        if (module_id == this.systemmoduleList[i]._id) {
          this.systemmoduleList[i].value = is_module;
          //flat array
          this.systemmoduleList[i].section = $.map(this.systemmoduleList[i].section, function (n) {
            return n;
          });
          //Sections
          for (var j = 0; j < this.systemmoduleList[i].section.length; j++) {
            this.systemmoduleList[i].section[j].value = is_module;
            for (var k = 0; k < this.systemmoduleList[i].section[j].section_action.length; k++) {
              this.systemmoduleList[i].section[j].section_action[k].value = is_module;
              //Action Tags
              for (var l = 0; l < this.systemmoduleList[i].section[j].section_action[k].section_action_tags.length; l++) {
                this.systemmoduleList[i].section[j].section_action[k].section_action_tags[l].value = is_module;
              }
              //supporting Actions
              for (var m = 0; m < this.systemmoduleList[i].section[j].section_action[k].supporting_actions.length; m++) {
                this.systemmoduleList[i].section[j].section_action[k].supporting_actions[m].value = is_module;
              }
            }
          }
        }
      }
      var index = 0
      this.systemmoduleList.forEach(a_module => {
        this.systemmoduleList[index++].section = this.getMatchedSection(a_module.section)
      });
    }
  }
  changesectionStatus(section_value: any, section_id: any) {
    var is_section: boolean = false;
    if (section_value == false) {
      is_section = true;
    }
    else {
      is_section = false;
    }
    //iterate modules
    this.systemmoduleList.forEach(a_module => {
      a_module.section = $.map(a_module.section, function (n) {
        return n;
      });
      //iterate Section
      a_module.section.forEach(section => {
        if (section.inherited_from) {
          if (section_id == section.inherited_from) {
            section.value = is_section;
            //iterate Actions
            section.section_action.forEach(action => {
              action.value = is_section;

              //iterate Tags
              action.section_action_tags.forEach(tag => {
                tag.value = is_section
              });
              //iterate Supporting Actions
              action.supporting_actions.forEach(supporting_action => {
                supporting_action.value = is_section
              });
            })
          }
        }
        if (section_id == section._id) {
          section.value = is_section
          //iterate Actions
          section.section_action.forEach(action => {
            action.value = is_section;
            //iterate Tags
            action.section_action_tags.forEach(tag => {
              tag.value = is_section
            });
            //iterate Supporting Actions
            action.supporting_actions.forEach(supporting_action => {
              supporting_action.value = is_section
            });
          })
        }
      })
    });
    var index = 0
    this.systemmoduleList.forEach(a_module => {
      this.systemmoduleList[index++].section = this.getMatchedSection(a_module.section)
    });

  }

  changesectionactionStatus(action_value: any, action_id: any) {
    var is_sectionaction: boolean = false
    if (action_value == false) {
      is_sectionaction = true;
    }
    else {
      is_sectionaction = false;
    }
    //iterate modules
    this.systemmoduleList.forEach(a_module => {
      a_module.section = $.map(a_module.section, function (n) {
        return n;
      });
      //iterate Section
      a_module.section.forEach(section => {
        //iterate Actions
        section.section_action.forEach(action => {
          if (action_id == action._id) {
            action.value = is_sectionaction;
            //iterate Tags
            action.section_action_tags.forEach(tag => {
              tag.value = is_sectionaction
            });
            //iterate Supporting Actions
            action.supporting_actions.forEach(supporting_action => {
              supporting_action.value = is_sectionaction
            });
          }
        })
      })
    });

    var index = 0
    this.systemmoduleList.forEach(a_module => {
      this.systemmoduleList[index++].section = this.getMatchedSection(a_module.section)
    });
  }
  changeactionTagStatus(tag_value: any, tag_id: any) {
    var is_actiontag: boolean = false;
    if (tag_value == false) {
      is_actiontag = true;
    }
    else {
      is_actiontag = false;
    }
    for (var i = 0; i < this.systemmoduleList.length; i++) {
      //flat array
      this.systemmoduleList[i].section = $.map(this.systemmoduleList[i].section, function (n) {
        return n;
      });
      //iterate Sections
      for (var j = 0; j < this.systemmoduleList[i].section.length; j++) {

        //iterate Actions
        if (this.systemmoduleList[i].section[j].section_action) {
          for (var k = 0; k < this.systemmoduleList[i].section[j].section_action.length; k++) {
            //iterate Tags
            for (var l = 0; l < this.systemmoduleList[i].section[j].section_action[k].section_action_tags.length; l++) {
              if (tag_id == this.systemmoduleList[i].section[j].section_action[k].section_action_tags[l]._id) {
                this.systemmoduleList[i].section[j].section_action[k].section_action_tags[l].value = is_actiontag;
              }
            }
          }
        }
      }
    }
    var index = 0
    this.systemmoduleList.forEach(a_module => {
      this.systemmoduleList[index++].section = this.getMatchedSection(a_module.section)
    });
  }
  save() {
    this.isLoading = true;
    delete this.systemmoduleList.message;
    this.systemmoduleList.modified_by = this.user_id;
    this.systemmoduleList.modified_by_name = this.username;
    for (var i = 0; i < this.systemmoduleList.length; i++) {
      //flat array
      this.systemmoduleList[i].section = $.map(this.systemmoduleList[i].section, function (n) {
        return n;
      });
    }
   //let clientId=localStorage.getItem("org_id")
    this.authService.updatePermisions(this.systemmoduleList, this.id,this.clientId).subscribe((res:any )=> {
      this.isLoading = false;
      // this.listallsystemModeulesby_App_id();
     // this.getPermissionbyId();
     this.alertService.updateAlert(res.message);
    }, error => {
      this.isLoading = false;
      console.log(error)
      this.getPermissionbyId();
    },
    () => {

      });
  }
  getPermissionType(tag: string) {
    switch (tag) {
      case "1":
        return "View";
      case "2":
        return "Data";
      case "3":
        return "API";
      default:
        return "";

    }
    }
    showModule(module:any){
      if(this.mode==RoleTypeEnum.ORGANIZATION_ROLE)
      return true;
      return  ( module.visibileForClient || [] ).some(x => x == this.clientId)
    }
    isDisabled(module:any){
      if(this.mode==RoleTypeEnum.ORGANIZATION_ROLE)
      return false;
      return  ( module.disabledForClient || [] ).some(x => x == this.clientId)
    }


  }
